const EarthIcon = ({ width, height, color }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.8"
      />
      <path
        d="M2.75 9H21.25"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M2.75 15H21.25"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M12 2.25C14.6487 4.88351 16.1364 8.46653 16.1364 12C16.1364 15.5335 14.6487 19.1165 12 21.75C9.35127 19.1165 7.86364 15.5335 7.86364 12C7.86364 8.46653 9.35127 4.88351 12 2.25Z"
        stroke={color}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EarthIcon;
